export function getChoiceLetter(index: number) {
  switch (index) {
    case 0: return "A";
    case 1: return "B";
    case 2: return "C";
    case 3: return "D";
    case 4: return "E";
    default: return null;
  }
}